import styled from 'styled-components';
import { CollapseSectionStyled } from 'pages/property/common/Common.styles';

export const PropertyNotesCollapseStyled = styled(CollapseSectionStyled)``;
